export const hasVirtualSessionType = (
  providerSessionTypeDisplayIds?: string[] | null,
): boolean => {
  return (
    providerSessionTypeDisplayIds?.some((id) =>
      ["phone", "telehealth"].includes(id),
    ) ?? false
  )
}
